export default __webpack_public_path__ + "media/pins/map-pin-gray-hover@2x-1db36d9c.png";